import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useShoppingCartStore } from '../../store/shoppingCart/shoppingCartStore';
import { BigButton } from '../BigButton';

import { AnimatePresence } from 'framer-motion';
import animations from '../../helpers/animations';
import { useModalShoppingStore } from '../../store/shopping/modalShoppingStore';
import { Checkbox } from '../Checkbox';
import {
    BackgroundModal,
    ButtonsWrap,
    ModalContent,
    ModalWrapper,
    RemovingElementWrap,
} from './styles';

export const AddingAdvancedModal: React.FC = () => {
    const { cartIsVisible, setCartValues, setCartIsVisible } =
        useShoppingCartStore();
    const {
        difficultLevelElement,
        setViewDifficultyLevel,
        setDifficultLevelElement,
    } = useModalShoppingStore();

    const [seenDifficult, setSeenDificult] = useState(false);

    function addingAdvancedToCard() {
        if (!difficultLevelElement) return;

        //Add ao carrinho
        setCartValues(difficultLevelElement);

        //Mostra ou não a modal novamente
        setViewDifficultyLevel(!seenDifficult);

        //Retira do estado global e tira a modal da visualização
        setDifficultLevelElement(null);

        if (!cartIsVisible) {
            setCartIsVisible(true);
        }
    }

    const modalRef = useRef<HTMLDivElement | null>(null);

    const closeModal = useCallback(
        (e: React.MouseEvent<HTMLDivElement>) => {
            if (modalRef.current === e.target) {
                setDifficultLevelElement(null);
            }
        },
        [setDifficultLevelElement]
    );

    const keyPress = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Escape' && !!difficultLevelElement) {
                setDifficultLevelElement(null);
            }
        },
        [difficultLevelElement, setDifficultLevelElement]
    );

    useEffect(() => {
        document.addEventListener('keydown', keyPress);

        return () => {
            document.removeEventListener('keydown', keyPress);
        };
    }, [keyPress]);

    return ReactDOM.createPortal(
        <AnimatePresence>
            {difficultLevelElement && (
                <BackgroundModal
                    ref={modalRef}
                    onClick={closeModal}
                    {...animations.calendar}
                >
                    <ModalWrapper>
                        <p>Nível de dificuldade</p>

                        <ModalContent>
                            <RemovingElementWrap>
                                <span>
                                    Você está prestes a adicionar uma sessão de
                                    ondas de um nível de{' '}
                                    <strong>dificuldade alto</strong> ao seu
                                    carrinho. Lembre-se, a prática leva à
                                    perfeição! Tem certeza de que deseja
                                    continuar?
                                </span>

                                <Checkbox
                                    statusCheck={seenDifficult}
                                    descriptionCheck="Não mostrar esta mensagem novamente"
                                    onClickCheck={() =>
                                        setSeenDificult(prev => !prev)
                                    }
                                />

                                <ButtonsWrap>
                                    <BigButton
                                        color="primary"
                                        bgColor="secondary"
                                        onClick={() =>
                                            setDifficultLevelElement(null)
                                        }
                                        allWidth
                                    >
                                        Cancelar
                                    </BigButton>
                                    <BigButton
                                        color="primary"
                                        bgColor="primary"
                                        onClick={addingAdvancedToCard}
                                        allWidth
                                    >
                                        Confirmar
                                    </BigButton>
                                </ButtonsWrap>
                            </RemovingElementWrap>
                        </ModalContent>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>,
        document.body
    );
};
